import { useEffect, useState } from "react";
import { Radio } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../ui/dialog";
import { Field, Sel, inputCls } from "../Form";
import { errMsg, money, useApi } from "../../lib/api";

export const GoLiveDialog = ({ roomId, me, onLive }) => {
  const api = useApi();
  const [open, setOpen] = useState(false);
  const [shows, setShows] = useState([]);
  const [showId, setShowId] = useState("");
  const [title, setTitle] = useState("Live show");
  useEffect(() => {
    if (!open) return;
    api.get("/shows").then(({ data }) => setShows(data.filter((s) => s.room_id === roomId && s.status === "scheduled" && (me.role === "admin" || s.host_id === me.user_id))));
  }, [open, api, roomId, me]);
  const go = async () => {
    try {
      await api.post(`/rooms/${roomId}/live`, showId ? { show_id: showId } : { title });
      toast.success("You're ON AIR — the show ends automatically after 1 hour");
      setOpen(false);
      onLive();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="go-live-btn" className="flex items-center gap-2 rounded-[3px] bg-pink-500 px-3.5 py-2 text-sm font-bold text-white hover:bg-pink-400 transition-colors glow-pink">
          <Radio className="h-4 w-4" /> Go Live
        </button>
      </DialogTrigger>
      <DialogContent className="bg-[#141419] border-[#2d2d38]" data-testid="go-live-dialog">
        <DialogHeader><DialogTitle>Go ON AIR</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <Field label="Show">
            <Sel value={showId} onChange={setShowId} testId="go-live-show-select" placeholder="New free show (open to members)"
              options={shows.map((s) => ({ value: s.id, label: `${s.title} · ${s.price > 0 ? money(s.price) : "Free"}` }))} />
          </Field>
          {!showId && <Field label="Title"><input value={title} onChange={(e) => setTitle(e.target.value)} className={inputCls} data-testid="go-live-title-input" /></Field>}
          <p className="text-xs text-zinc-500">Shows run for up to one hour, then go OFF AIR on their own.</p>
          <button onClick={go} data-testid="go-live-confirm-btn" className="w-full rounded-[3px] bg-pink-500 py-2.5 font-bold text-white hover:bg-pink-400">Start the show</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
